import React from 'react';
import { Box, IconButton, TextField, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  CLIENT_TAG_PRESET_COLORS,
  getContrastText,
  isValidHexColor,
  normalizeHexColor,
} from '../../utils/clientTags';

export default function ClientTagColorPicker({ value, onChange, size = 'small' }) {
  const { t } = useTranslation();
  const color = normalizeHexColor(value);
  const hexInvalid = value && !isValidHexColor(value);

  return (
    <Stack spacing={1}>
      <Stack direction="row" flexWrap="wrap" gap={0.75} alignItems="center">
        {CLIENT_TAG_PRESET_COLORS.map((preset) => {
          const selected = preset.toUpperCase() === color.toUpperCase();
          return (
            <IconButton
              key={preset}
              size="small"
              onClick={() => onChange(preset)}
              aria-label={preset}
              sx={{
                width: 28,
                height: 28,
                bgcolor: preset,
                border: selected ? 2 : 1,
                borderColor: selected ? 'primary.main' : 'divider',
                '&:hover': { bgcolor: preset, opacity: 0.85 },
              }}
            />
          );
        })}
        <Box component="label" sx={{ position: 'relative', display: 'inline-flex' }}>
          <IconButton
            component="span"
            size="small"
            sx={{
              width: 28,
              height: 28,
              bgcolor: color,
              color: getContrastText(color),
              border: 1,
              borderColor: 'divider',
              fontSize: '0.65rem',
              fontWeight: 700,
            }}
          >
            +
          </IconButton>
          <input
            type="color"
            value={color}
            onChange={(e) => onChange(e.target.value.toUpperCase())}
            style={{
              position: 'absolute',
              opacity: 0,
              width: 28,
              height: 28,
              cursor: 'pointer',
            }}
            aria-label={t('common.customColor')}
          />
        </Box>
      </Stack>
      <TextField
        size={size}
        label={t('common.customColor')}
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        error={hexInvalid}
        helperText={hexInvalid ? t('settings.clientTags.invalidColor') : ' '}
        inputProps={{ maxLength: 7 }}
        sx={{ maxWidth: 140 }}
      />
    </Stack>
  );
}
